// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"88e0f655","658":"611d1843","963":"8a615524"}[chunkId] + ".chunk.js";
};